import { IAttendee } from "./Attendee";
import { IAvailabilityWindow } from "./AvailabilityWindow";
import { ICalendar } from "./Calendar";
import { IProject } from "./Project";

export enum SchedulerType {
    PROSPECT = "prospect",
    INVEST = "invest",
    ONBOARDING = "onboarding",
    INTRO = "intro",
    DEMO = "demo",
    TRIAL = "trial",
    OTHER = "other",
}

export interface IScheduler {
    id: number;
    uuid: string;
    type: SchedulerType;
    timezone: string;
    is_available: boolean;
    is_active: boolean;
    scheduling_url: string;
    created_at: string;
    updated_at: string;
    calendars: ICalendar[];
    availability_windows: IAvailabilityWindow[];
    attendees: IAttendee[];
    internal_attendee: string;
    project: IProject;
    provider: string;
    is_default: boolean;
    is_deleted: boolean;
}